import { Fade, Stack, Typography } from '@mui/material';
import { useAppSelector } from '../redux/store';
import { OnboardingV2Step } from '../redux/onboardingTypes';
import { useTranslation } from 'react-i18next';

export default function SYDLeftPanel() {
  const onboardingStep = useAppSelector(
    (state) => state.onboarding.onboardingStep
  );

  const { t } = useTranslation();

  return (
    <>
      {onboardingStep === OnboardingV2Step.ANIMATING && (
        <Fade in={true}>
          <Stack
            justifyContent="center"
            alignItems={'center'}
            gap="10px"
            className="absolute top-[100%] left-[50%] -translate-x-[50%]"
          >
            <Typography className="font-semibold text-[24px] macbook13:text-[16px] text-[#292D3233] whitespace-pre text-center">
              {t('sydCaresAboutYourPrivacy')}
            </Typography>
          </Stack>
        </Fade>
      )}
    </>
  );
}
